import { List } from "@tm/controls"
import { useLocalization } from "@tm/localization"
import { IArticle } from "../../../data/models"
import { DopCollapsible } from "../_shared"
import ArticleItem from "../_shared/articleItem"
import { useDutchOrderPlatesStore } from "../../../data/state"

export default function Articles() {
    const articles = useDutchOrderPlatesStore((state) => state.dutchOrderPlates.model.articles)
    const { translateText } = useLocalization()

    if (!articles?.length) {
        return null
    }

    const renderArticle = (x: IArticle) => <ArticleItem item={x} />

    return (
        <DopCollapsible title={translateText(90)}>
            <List items={articles} view={renderArticle} />
        </DopCollapsible>
    )
}
